import { render, staticRenderFns } from "./blackGdids.vue?vue&type=template&id=83a97140&"
import script from "./blackGdids.vue?vue&type=script&lang=js&"
export * from "./blackGdids.vue?vue&type=script&lang=js&"
import style0 from "./blackGdids.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports